// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3dLTw","label":"Category_label__2vfOz","content":"Category_content__1Dk-_","header":"Category_header__RkG-w","location":"Category_location__lP-XC"};